import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OECellTargetType, OECellTargets, OECellFeatureAccess, OECellStartSelectionData} from './oe-cell-model';

export default class OECellCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OECellTargetType.cells]:           {icon: OEIconCodes.cell.cellsTarget, noTargetTypeBarEntry: true, titleId: 'cap_bar_target_title_cells'},
            [OETarget.effigosExplorerHelp]:     {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = [OECellTargetType.cells, OETarget.effigosExplorerHelp];

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OECellTargets}
                featureAccess={OECellFeatureAccess}
                startSelectionData={OECellStartSelectionData}
            />
        );
    }
}